import { useState, useEffect, useRef, memo, useCallback } from "react";

import './App.scss';
import { Header } from "./header.js";

let fileovi = ["avion2.png", "babuska.png", "balon.png", "banana.png", "demetra.png", "dinamit.png",
 "drvo.png", "faraon.png", "globus.png", "jabuka.jpg", "jagoda.png", "kamion.png", "klupko.png", "knjige.png", 
 "kocka.png", "kocka1.png", "koktel.png", "konj.png", "krevet.png", "kruh.png", "krv.png", "lampa.png", 
 "lav.png", "leptir.png", "majmun.jpg", "man.png", "medo.png", "neboder1.jpg", "novac.png", "orange.jpg", 
 "paket.png", "sat.png", "srce.png", "taxi.png", "trska.png", "vagon.png", "woman.png", "zarulja.png", "zicara.png"];

function IzborniElement({tx, lev, setLevel}) {

  let klikFun = (e) => {console.log("Kliknuo si izbornik " + lev); setLevel(lev);}
  return (
    <div onClick = {klikFun} className="izborniElement">{tx}</div>
  )
}

function Kartica({slika="", br, cls="", brOtv=0, klikKartica=()=>{}, akcija={}}) {
  const [rotSw, setRotSw] = useState(false);
  const [stil, setStil] = useState({"transform": "rotateY(0deg)"});
  const [sw, setSw] = useState(true);

  const ref = useRef(null);

  useEffect(()=>{
    if (rotSw) {
      setStil((prev)=> {return {...prev, "transform": "rotateY(180deg)"}});
    } else {
      setStil((prev)=> {return {...prev, "transform": "rotateY(0deg)"}});
    }
  }, [rotSw]);

  useEffect(()=>{
    if (rotSw && akcija.action == "zatvori") {
      setRotSw(false);
    } else if (rotSw && akcija.action == "izbrisi") {
      /*setStil((prev)=>{return {...prev, "opacity": "0"} });*/
      ref.current.style.opacity = "0";
      setSw(false);
    }
  }, [akcija]);

  useEffect(()=>{
    console.log("iniciran je " + br);
    if (br == 36) {
        console.timeEnd("vrijeme");
    }
  }, [])

  function klik() {
    if (sw && brOtv < 2 && !rotSw) {
        setRotSw((prev)=>{return !prev});
        klikKartica(br);
    }
  }

  return (
    <div className={cls} key={br} ref={ref}>
      <div onClick={klik} className="flipper" style={stil}>
        <div className="front">{br}</div>
        <div className="back" style={{"backgroundImage": "url("+ slika + ")"}}></div>
      </div>
    </div>
  )
}

const Ploca = memo(function({br, podaci=[], brOtv=0, klikKartica=()=>{}, akcija={}}) {
  /*const [polje, setPolje] = useState([]);*/
  const [tip, setTip] = useState("");

  useEffect(()=>{
    console.log("podaci su ");
    console.log(podaci);
  }, [podaci]);

  useEffect(()=>{
    /*let p = [];
    for (let i = 0; i < br; i++) {
      p.push(i+1);
    }
    setPolje([...p]);*/
    setTip("tip"+br);
    console.log("postavljamo " + br + " kartica...")
  }, [br]);

  return (
    <div className="ploca">
      {podaci.map((el)=>{return <Kartica slika={el.slika} key={el.br} br={el.br} cls={"kartica " + tip} 
                                   brOtv={brOtv} klikKartica={klikKartica} akcija={akcija}/>})}
    </div>
  )
});

function App() {
  const [level, setLevel] = useState(0);
  const [br, setBr] = useState(0)
  const [moves, setMoves] = useState(0);
  const [podaci, setPodaci] = useState([]);
  const [brOtv, setBrOtv] = useState(0);
  const [akcija, setAkcija] = useState({"action":null});
  const [otvKar, setOtvKar] = useState([]);

  const ref = useRef(null);
  const ref1 = useRef(null);

  useEffect(()=>{
    if (brOtv == 2) {
      if (podaci[otvKar[0]-1].slika == podaci[otvKar[1]-1].slika) {
        
        ref.current = setTimeout(()=>{
          setAkcija({"action": "izbrisi", "cards":[...otvKar]});
          /*setMoves((prev)=>{return prev+1});*/
        }, 2000);
      } else {
        ref.current = setTimeout(()=>{
          setAkcija({"action": "zatvori"});
          /*setMoves((prev)=>{return prev+1});*/
        }, 2000);
      }
      ref1.current = setTimeout(()=>{setBrOtv(0)}, 2500);
      setMoves((prev)=>{return prev+1});
      setOtvKar([]);
    } 
  }, [brOtv]);
  
  useEffect(()=>{
    switch(level) {
      case 0:
        setBr(0);
        break;
      case 1:
        setBr(12);
        break;
      case 2:
        setBr(16);
        break;
      case 3:
        setBr(20);
        break;
      case 4:
        setBr(24);
        break;
      case 5:
        setBr(30);
        break;
      case 6:
        setBr(36);
        break;
    }
    if (level == 6)  console.time("vrijeme");

    setAkcija({"action":null});
    setBrOtv(0);


  }, [level]);

  useEffect(()=>{
    let izbor = randomPoljeSlika(br/2, 2);
    setPodaci(izbor.map((sl, ind)=>{return {"br": ind+1, "slika": "/slike/"+sl}}));
  }, [br]);

  useEffect(()=>{
    loadFun();

    /*randomPoljeSlika(3,2);*/
    /*randomShuffle(fileovi);*/
    /*console.log(randomPoljeSlika(3,3));*/
  },[]); 

  function randomShuffle(polje) {
    let l = polje.length;
    for (let i = 0; i < l-1; i++) {
      let odabir = Math.floor(Math.random()*(l-i)+i);
      let tp = polje[i];
      polje[i] = polje[odabir];
      polje[odabir] = tp;
    }
  }

  function randomPoljeSlika(br, step) {
    let l = fileovi.length;
    if (br > l)  return [];
    console.log("ides  ");
    
    randomShuffle(fileovi);
    let slc = fileovi.slice(0,br);
    let rezPolje = [];
    for (let i = 0; i < step; i++) {
      rezPolje = [...rezPolje, ...slc];
    }
    randomShuffle(rezPolje);
    return rezPolje;
  }

  function loadFun() {
    console.log("Cijela stranica je potpuno ucitana... " + Math.random());
    //setLoadSw(true);

    // helper kod za dizajn stranice
    document.addEventListener("keydown", (e) => {pritisakGumba(e)});
    let ell = document.querySelector("html");
    function pritisakGumba(e) {
      if (e.code === "KeyS") {
        console.log("sirina/visina prozora su " + ell.clientWidth + " / " + ell.clientHeight);
        console.log(Math.random());
      }
    }
  }

  function newGameFun() {
    setLevel(0);
    setBr(0);
    setMoves(0);
  }

  const klikKartica = useCallback((br) => {
    setBrOtv((prev)=>{return prev+1});
    console.log("otvorio si sliku " + br);
    console.log(podaci[br-1]);
    setOtvKar((prev)=>{return [...prev, br]});
  }, []);



  return (
    <div className="App">
      <Header welcomeSw={!level} lev={level} brCards={br} moves={moves} newGameFun={newGameFun}></Header>
      {!level ?
      <>
        <IzborniElement setLevel={setLevel} lev={1} tx="Level 1: 12 cards"/>
        <IzborniElement setLevel={setLevel} lev={2} tx="Level 2: 16 cards"/>
        <IzborniElement setLevel={setLevel} lev={3} tx="Level 3: 20 cards"/>
        <IzborniElement setLevel={setLevel} lev={4} tx="Level 4: 24 cards"/>
        <IzborniElement setLevel={setLevel} lev={5} tx="Level 5: 30 cards"/>
        <IzborniElement setLevel={setLevel} lev={6} tx="Level 6: 36 cards"/>
      </> :  <Ploca podaci={podaci} br={br} klikKartica={klikKartica} brOtv={brOtv} akcija={akcija}/>}
    </div>
  );
}

export default App;
